import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 15C12.1569 15 13.5 16.3431 13.5 18C13.5 19.6569 12.1569 21 10.5 21C8.84315 21 7.5 19.6569 7.5 18C7.5 16.3431 8.84315 15 10.5 15Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.5 8.5L19 11L14.4502 17.3691C14.1477 15.4598 12.4945 14 10.5 14L11.5 13L4.5 10L12.4971 3.99316L10.5 8.5Z"}}]};

const GitCommit1Filled = Vue.extend<IconProps>({
  name: 'GitCommit1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'git-commit-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GitCommit1Filled;
